import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("C:/Users/Strains/Desktop/michael-strain/layouts/default.vue").then(m => m.default || m))
}